import { PropTypes } from 'prop-types';


export const Content = ({ children, isActive }) => {

    return (
        <div
            className={`  h-full ${isActive ? '' : 'hidden'
                }`}
            role="tabpanel"
        >
            {children}
        </div>
    );
};

Content.propTypes = {
    children: PropTypes.node,
    isActive: PropTypes.bool,
};

const Contents = ({ contents,activeTab }) => {

        

    return (
        <div className='p-2 md:p-8'>
                {contents?.map((content, index) => (
                    <Content key={index} isActive={index === activeTab}>
                        {content}
                    </Content>
                ))}
            </div>
    );
};

Contents.propTypes = {
    headers: PropTypes.arrayOf(PropTypes.string),
    contents: PropTypes.arrayOf(PropTypes.node),
    activeTab:PropTypes.number
};

export default Contents;
